import { ModalFooter } from 'react-bootstrap';
import ModalFormCancelButton from './ModalFormCancelButton';
import ModalFormSubmitButton from './ModalFormSubmitButton';

const ModalFormFooter = () => {
  return (
    <ModalFooter>
      <ModalFormCancelButton />
      <ModalFormSubmitButton />
    </ModalFooter>
  );
};

export default ModalFormFooter;
